export * from './calculate-discount';
export * from './confetti';
export * from './error-handler';
export * from './extract-image-src';
export * from './extract-university-id';
export * from './format-duration';
export * from './get-app-link';
export * from './get-platform';
export * from './infinite-next-page-param';
export * from './is-browser';
export * from './is-empty-arr';
export * from './load-yandex-map';
export * from './localstorage';
export * from './parse-subject-name';
export * from './remove-image-tag';
export * from './slugify';
export * from './strip-html-tags';
export * from './time-ago';
export * from './track-yandex-goal';
export * from './truncate-text';
export * from './use-back';
